import React, { useState } from 'react'
import { AiOutlineCloudUpload } from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';
import { MdDelete } from 'react-icons/md';

import { categories } from '../utils/data';
import { client } from '../client';
import Spinner from './Spinner';

const CreatePin = ({ user }) => {
    const [title, setTitle] = useState('');
    const [about, setAbout] = useState('');
    const [loading, setLoading] = useState(false);
    const [destination, setDestination] = useState();
    const [fields, setFields] = useState(false);
    const [category, setCategory] = useState();
    const [imageAsset, setImageAsset] = useState();
    const [wrongImageType, setWrongImageType] = useState(false);

    const navigate = useNavigate()

    //uploadImage Function
    const uploadImage = (e) => {
        const { type, name } = e.target.files[0]

        if (type === 'image/png' || type === 'image/svg' || type === 'image/jpeg' || type === 'image/gif' || image === 'image/tiff') {
            setWrongImageType(false)
            setLoading(true)

            client.assets
                //if it is an file mention video instead of  image
                .upload('image', e.target.files[0], { contentType: type, filename: name })
                .then((document) => {
                    setImageAsset(document)
                    setLoading(false)
                })
                .catch((error) => {
                    console.log(error)
                })
        } else {
            setWrongImageType(true)
        }
    }

    const savePin = () => {
        if (title && imageAsset?._id && category) {
            const doc = {
                _type: 'pin',
                title,
                about,
                destination,
                image: {
                    _type: 'image',
                    asset: {
                        _type: 'reference',
                        _ref: imageAsset?._id,
                    },
                },
                userId: user._id,
                postedBy: {
                    _type: 'postedBy',
                    _ref: user._id,
                },
                category,
            };
            client.create(doc).then(() => {
                navigate('/');
            });
        } else {
            setFields(true);

            setTimeout(
                () => {
                    setFields(false);
                },
                2000,
            );
        }
    }

    return (
        <div className="flex flex-col justify-center items-center mt-5 lg:h-4/5 bg-gray-800 rounded-lg">
            {fields && (
                <p className="text-red-500 mb-5 text-xl transition-all duration-150 ease-in ">Please add all fields.</p>
            )}
            <div className=" flex lg:flex-row flex-col justify-center items-center bg-gray-800 rounded-lg lg:p-5 p-3 lg:w-4/5  w-full">
                <div className="bg-gray-700 rounded-lg p-3 flex flex-0.7 w-full">
                    <div className=" flex justify-center items-center flex-col border-2 border-dotted border-gray-900 p-3 w-full h-auto">
                        {loading && (
                            <Spinner />
                        )}
                        {
                            wrongImageType && (
                                <p>It&apos;s wrong file type.</p>
                            )
                        }
                        {
                            !imageAsset ? (
                                <label>
                                    <div className="flex flex-col items-center justify-center h-full">
                                        <div className="flex flex-col justify-center items-center">
                                            <p className="font-bold text-2xl">
                                                <AiOutlineCloudUpload />
                                            </p>
                                            <p className="text-lg">Click to upload</p>
                                        </div>
                                    </div>
                                    <input
                                        type="file"
                                        name="upload-image"
                                        onChange={uploadImage}
                                        className="w-0 h-0"
                                    />
                                </label>
                            ) : (
                                <div className="relative h-full">
                                    <img
                                        src={imageAsset?.url}
                                        alt="uploaded-pic"
                                        className="h-auto w-auto"
                                    />
                                    <button
                                        type="button"
                                        className="absolute bottom-3 right-3 p-3 rounded-full bg-gray-900 text-xl cursor-pointer outline-none hover:shadow-md transition-all duration-500 ease-in-out"
                                        onClick={() => setImageAsset(null)}
                                    >
                                        <MdDelete />
                                    </button>
                                </div>
                            )
                        }
                    </div>
                </div>
                {/* Forms starts here */}
                <div className="flex flex-1 flex-col gap-6 lg:pl-5 mt-5 w-full">
                    {user && (
                        <div className="flex gap-2 mt-2 mb-2 p-1 items-center bg-gray-900 rounded-full text-gray-400">
                            <img
                                src={user.image}
                                className="w-10 h-10 rounded-full"
                                alt="user-profile"
                            />
                            <p className="font-bold">{user.userName}</p>
                        </div>
                    )}
                    <input
                        type="text"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        placeholder="Add your title"
                        className="outline-none text-lg sm:text-lg font-bold  p-2 bg-gray-900 rounded-full text-gray-400"
                    />
                    <input
                        type="text"
                        value={about}
                        onChange={(e) => setAbout(e.target.value)}
                        placeholder="About Powlli"
                        className="outline-none text-base sm:text-lg bg-gray-900 rounded-full text-gray-400 p-2"
                    />
                    <input
                        type="url"
                        vlaue={destination}
                        onChange={(e) => setDestination(e.target.value)}
                        placeholder="Web URL (Optional)"
                        className="outline-none text-base sm:text-lg bg-gray-900 rounded-full text-gray-400 p-2"
                    />
                    <div className="flex flex-col">
                        <div>
                            <p className="mb-2 font-semibold text:lg sm:text-xl">Choose Pin Category</p>
                            <select
                                onChange={(e) => {
                                    setCategory(e.target.value);
                                }}
                                className="outline-none w-4/5 text-base bg-gray-900 rounded-full text-gray-400 p-2  cursor-pointer"
                            >
                                <option value="others" className="sm:text-bg bg-white">Select Category</option>
                                {categories.map((item) => (
                                    <option className="text-base border-0 outline-none capitalize bg-white text-black " value={item.name}>
                                        {item.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="flex justify-end items-end mt-5">
                            <button
                                type="button"
                                onClick={savePin}
                                className="bg-rose-600 text-white font-bold p-2 rounded-full w-28 outline-none"
                            >
                                Save Pin
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CreatePin
